// LIST
export const FETCH_REVIEWS = "app/Reviews/FETCH_REVIEWS";
export const FETCH_REVIEWS_SUCCESS = "app/Reviews/FETCH_REVIEWS_SUCCESS";
export const FETCH_REVIEWS_FAILURE = "app/Reviews/FETCH_REVIEWS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Reviews/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Reviews/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Reviews/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_REVIEWS = "app/Reviews/ADD_REVIEWS";
export const ADD_REVIEWS_SUCCESS = "app/Reviews/ADD_REVIEWS_SUCCESS";
export const ADD_REVIEWS_FAILURE = "app/Reviews/ADD_REVIEWS_FAILURE";
// EDIT
export const EDIT_REVIEWS = "app/Reviews/EDIT_REVIEWS";
export const EDIT_REVIEWS_SUCCESS = "app/Reviews/EDIT_REVIEWS_SUCCESS";
export const EDIT_REVIEWS_FAILURE = "app/Reviews/EDIT_REVIEWS_FAILURE";
// DELETE
export const DELETE_REVIEWS = "app/Reviews/DELETE_REVIEWS";
export const DELETE_REVIEWS_SUCCESS = "app/Reviews/DELETE_REVIEWS_SUCCESS";
export const DELETE_REVIEWS_FAILURE = "app/Reviews/DELETE_REVIEWS_FAILURE";
// MODAL
export const TOGGLE_MOD_MODAL = "app/Reviews/TOGGLE_MOD_MODAL";

export const FETCH_UPLOADS = "app/Reviews/FETCH_UPLOADS";
export const FETCH_UPLOADS_SUCCESS = "app/Reviews/FETCH_UPLOADS_SUCCESS";
export const FETCH_UPLOADS_FAILURE = "app/Reviews/FETCH_UPLOADS_FAILURE";

export const ADD_REVIEW_CARD = "app/Reviews/ADD_REVIEW_CARD";
export const ADD_REVIEW_CARD_SUCCESS = "app/Reviews/ADD_REVIEW_CARD_SUCCESS";
export const ADD_REVIEW_CARD_FAILURE = "app/Reviews/ADD_REVIEW_CARD_FAILURE";

export const EDIT_REVIEW_CARD = "app/Reviews/EDIT_REVIEW_CARD";
export const EDIT_REVIEW_CARD_SUCCESS = "app/Reviews/EDIT_REVIEW_CARD_SUCCESS";
export const EDIT_REVIEW_CARD_FAILURE = "app/Reviews/EDIT_REVIEW_CARD_FAILURE";

export const GET_CARD_DATA = "app/Reviews/GET_CARD_DATA";
export const GET_CARD_DATA_SUCCESS = "app/Reviews/GET_CARD_DATA_SUCCESS";
export const GET_CARD_DATA_FAILURE = "app/Reviews/GET_CARD_DATA_FAILURE";
